"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeverageButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _APLabelWithText = _interopRequireDefault(require("../../../common/APLabelWithText"));
var _Button = require("../../../form/Button/Button");
var _useLeverageButton2 = require("./useLeverageButton");
require("./LeverageButton.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('leverage-button');
var LeverageButton = exports.LeverageButton = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var formName = _ref.formName;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var _useLeverageButton = (0, _useLeverageButton2.useLeverageButton)(formName),
    leverage = _useLeverageButton.leverage,
    disabled = _useLeverageButton.disabled,
    noLeverage = _useLeverageButton.noLeverage,
    onClick = _useLeverageButton.onClick;
  return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Leverage'),
    text: /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      disabled: disabled,
      onClick: onClick,
      variant: "secondary",
      size: "sm",
      type: "button"
    }, noLeverage ? t('No Leverage') : "".concat(leverage, "x")),
    customClass: baseClasses()
  });
});
LeverageButton.displayName = 'LeverageButton';